
import { createSlice } from "@reduxjs/toolkit";

const loaderSlice = createSlice({
  name: "loader",
  initialState: { loading: false }, // Initial loader state
  reducers: {
    showLoader: (state) => {
      state.loading = true; // Loader ON
    },
    hideLoader: (state) => {
      state.loading = false; // Loader OFF
    },
  },
});

export const { showLoader, hideLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
